export default "__VITE_ASSET__5e621e3e__"